module.exports = __webpack_public_path__ + "img/thumbnail_PrairieDog_f_normal.491e02a0.png";